'use client';

import { c as _c } from "react/compiler-runtime";
import dynamic from 'next/dynamic';
import { Suspense } from 'react';
const LazyLottie = dynamic(async () => import('lottie-react').then(res => res.default), {
  ssr: false
});
export default function LogoAnimated(props) {
  const $ = _c(5);
  let t0;
  if ($[0] !== props) {
    t0 = <LazyLottie animationData={LOGO_ANIMATION} loop={false} {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="sr-only">Funkey logo</span>;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t0) {
    t2 = <Suspense>{t0}{t1}</Suspense>;
    $[3] = t0;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
const LOGO_ANIMATION = {
  v: '4.8.0',
  meta: {
    g: 'LottieFiles AE 3.4.4',
    a: '',
    k: '',
    d: '',
    tc: ''
  },
  fr: 30,
  ip: 0,
  op: 60,
  w: 1500,
  h: 750,
  nm: 'funkeyLogo Lottie',
  ddd: 0,
  assets: [],
  layers: [{
    ddd: 0,
    ind: 1,
    ty: 4,
    nm: 'smile',
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 1,
        k: [{
          i: {
            x: [0.129],
            y: [1]
          },
          o: {
            x: [0.556],
            y: [0]
          },
          t: 9.6,
          s: [-20]
        }, {
          i: {
            x: [0.2],
            y: [1]
          },
          o: {
            x: [0.8],
            y: [0]
          },
          t: 24,
          s: [10]
        }, {
          t: 35.999609375,
          s: [0]
        }],
        ix: 10
      },
      p: {
        a: 1,
        k: [{
          i: {
            x: 0,
            y: 1
          },
          o: {
            x: 0.333,
            y: 0
          },
          t: 8.4,
          s: [696.87, 447.286, 0],
          to: [0, 43.667, 0],
          ti: [0, -18.833, 0]
        }, {
          i: {
            x: 0.2,
            y: 1
          },
          o: {
            x: 0.8,
            y: 0
          },
          t: 19.2,
          s: [696.87, 709.286, 0],
          to: [0, 18.833, 0],
          ti: [0, 24.833, 0]
        }, {
          t: 32.999609375,
          s: [696.87, 560.286, 0]
        }],
        ix: 2
      },
      a: {
        a: 0,
        k: [564.292, 436.705, 0],
        ix: 1
      },
      s: {
        a: 1,
        k: [{
          i: {
            x: [0.2, 0.2, 0.2],
            y: [1, 1, 1]
          },
          o: {
            x: [0.8, 0.8, 0.8],
            y: [0, 0, 0]
          },
          t: 22.2,
          s: [39, 39, 100]
        }, {
          t: 38.999609375,
          s: [100, 100, 100]
        }],
        ix: 6
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[1.665, -0.212], [3.12, -0.529], [4.415, -0.845], [5.605, -1.004], [3.013, -0.635], [3.357, -0.475], [7.508, -1.295], [8.248, -1.348], [8.908, -1.242], [9.543, -0.952], [4.757, -0.687], [4.917, -0.635], [5.049, -0.451], [5.023, -0.687], [2.564, -0.237], [2.591, -0.264], [5.234, -0.397], [5.234, -0.582], [5.34, -0.343], [2.67, -0.158], [2.697, -0.106], [5.393, -0.107], [5.419, -0.238], [1.295, -0.026], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [21.571, 1.084], [5.366, 0.291], [2.669, 0.105], [2.643, 0.212], [5.261, 0.397], [5.208, 0.45], [10.177, 0.899], [4.997, 0.502], [4.916, 0.556], [4.785, 0.582], [4.758, 0.502], [8.962, 1.084], [8.353, 1.11], [7.613, 1.058], [6.741, 0.926], [2.987, 0.581], [2.775, 0.475], [4.573, 0.924], [3.172, 0.501], [1.666, 0.238], [0, 0], [0, 0], [-4.758, -3.384], [-9.331, -5.948], [-5.684, -3.384], [-6.556, -3.964], [-7.533, -4.151], [-8.538, -3.993], [-4.494, -2.009], [-2.3, -1.031], [-2.352, -0.952], [-4.891, -1.956], [-5.075, -1.85], [-10.839, -3.462], [-5.577, -1.507], [-5.789, -1.216], [-5.842, -1.321], [-5.974, -1.084], [-3.04, -0.476], [-3.04, -0.424], [-6.16, -0.635], [-25.22, -0.317], [-12.821, 1.031], [-6.187, 0.714], [-6.16, 0.634], [-6.08, 0.819], [-3.04, 0.423], [-3.014, 0.528], [-5.895, 1.084], [-5.763, 1.295], [-5.605, 1.48], [-5.419, 1.718], [-10.125, 3.833], [-4.891, 1.904], [-4.706, 1.904], [-2.327, 0.926], [-2.221, 1.005], [-4.31, 1.929], [-7.667, 3.86], [-6.689, 3.702], [-5.684, 3.41], [-4.627, 2.961], [-4.811, 3.383], [0, 0], [0, 0]],
            o: [[-1.64, 0.237], [-3.145, 0.502], [-4.414, 0.82], [-2.801, 0.502], [-3.04, 0.607], [-6.742, 0.979], [-7.612, 1.031], [-8.354, 1.084], [-8.988, 1.057], [-4.733, 0.528], [-4.786, 0.608], [-4.917, 0.555], [-4.996, 0.502], [-2.511, 0.37], [-2.537, 0.265], [-5.129, 0.556], [-5.207, 0.475], [-5.261, 0.344], [-2.644, 0.212], [-2.696, 0.106], [-5.366, 0.238], [-5.419, 0.079], [-1.348, 0.053], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [-21.835, -0.212], [-5.393, -0.132], [-2.696, -0.106], [-2.671, -0.159], [-5.314, -0.476], [-5.234, -0.607], [-10.441, -0.819], [-5.049, -0.661], [-5.048, -0.423], [-4.917, -0.607], [-4.784, -0.687], [-9.517, -0.952], [-8.935, -1.242], [-8.222, -1.349], [-7.508, -1.269], [-3.384, -0.502], [-2.961, -0.609], [-5.578, -0.952], [-4.52, -0.9], [-3.172, -0.556], [-1.692, -0.212], [0, 0], [0, 0], [4.812, 3.357], [4.627, 2.987], [5.657, 3.41], [6.714, 3.702], [7.693, 3.833], [4.309, 1.929], [2.247, 1.005], [2.3, 0.952], [4.732, 1.904], [4.89, 1.93], [10.125, 3.833], [5.419, 1.718], [5.631, 1.48], [5.763, 1.268], [5.922, 1.084], [2.987, 0.528], [3.014, 0.449], [6.107, 0.819], [24.663, 2.908], [12.847, -0.396], [6.291, -0.45], [6.212, -0.635], [6.185, -0.662], [3.04, -0.424], [3.014, -0.476], [5.974, -1.111], [5.869, -1.321], [5.79, -1.189], [5.604, -1.507], [10.837, -3.463], [5.102, -1.85], [4.891, -1.956], [2.353, -0.952], [2.273, -1.031], [4.494, -2.009], [8.538, -4.019], [7.533, -4.15], [6.556, -3.964], [5.684, -3.41], [9.252, -5.894], [4.784, -3.411], [0, 0], [0, 0]],
            v: [[368.466, -65.216], [361.169, -64.185], [349.749, -62.228], [334.575, -59.612], [325.773, -58.052], [316.23, -56.307], [295.055, -52.5], [271.475, -48.456], [245.833, -44.331], [218.473, -40.26], [204.278, -38.279], [189.711, -36.427], [174.881, -34.576], [159.813, -32.806], [152.147, -32.066], [144.454, -31.273], [128.937, -29.792], [113.235, -28.391], [97.347, -27.334], [89.39, -26.673], [81.327, -26.329], [65.228, -25.404], [48.997, -24.743], [44.979, -24.558], [41.172, -24.558], [33.585, -24.373], [25.998, -24.135], [24.042, -24.082], [21.716, -24.109], [17.037, -24.056], [-0.04, -23.87], [-65.282, -25.536], [-81.381, -26.487], [-89.417, -26.831], [-97.374, -27.466], [-113.262, -28.55], [-128.965, -29.977], [-159.814, -33.017], [-174.883, -34.789], [-189.711, -36.639], [-204.252, -38.464], [-218.474, -40.472], [-245.808, -44.517], [-271.476, -48.613], [-295.055, -52.633], [-316.231, -56.386], [-325.695, -58.078], [-334.418, -59.584], [-349.645, -62.201], [-361.25, -64.237], [-368.599, -65.268], [-371.137, -65.612], [-376.185, -58.211], [-368.89, -53.003], [-347.98, -38.595], [-332.647, -28.682], [-314.301, -17.607], [-292.942, -5.789], [-268.648, 6.133], [-255.456, 12.028], [-248.663, 15.068], [-241.658, 17.896], [-227.25, 23.685], [-212.209, 29.158], [-180.565, 39.599], [-163.965, 44.174], [-146.888, 48.43], [-129.467, 52.315], [-111.622, 55.594], [-102.609, 57.206], [-93.515, 58.502], [-75.142, 61.013], [-0.04, 65.612], [37.63, 64.263], [56.479, 62.916], [75.063, 61.013], [93.435, 58.502], [102.555, 57.206], [111.569, 55.594], [129.386, 52.315], [146.833, 48.403], [163.884, 44.174], [180.486, 39.573], [212.128, 29.158], [227.17, 23.685], [241.577, 17.896], [248.609, 15.068], [255.376, 12.028], [268.568, 6.133], [292.862, -5.816], [314.221, -17.607], [332.593, -28.682], [347.873, -38.569], [368.836, -53.029], [376.185, -58.237], [371.004, -65.56]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [1, 1, 1, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [564.292, 436.705],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 1',
      np: 2,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }],
    ip: 8.4,
    op: 60,
    st: 8.4,
    bm: 0
  }, {
    ddd: 0,
    ind: 2,
    ty: 4,
    nm: 'F-mask-white',
    td: 1,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [750, 375, 0],
        ix: 2
      },
      a: {
        a: 0,
        k: [0, 0, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [0, 0]],
            o: [[0, 0], [0, 0]],
            v: [[-524, -69.75], [-388.25, -81.25]],
            c: false
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'st',
        c: {
          a: 0,
          k: [1, 0, 0, 1],
          ix: 3
        },
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 64,
          ix: 5
        },
        lc: 1,
        lj: 1,
        ml: 4,
        bm: 0,
        nm: 'Stroke 1',
        mn: 'ADBE Vector Graphic - Stroke',
        hd: false
      }, {
        ty: 'tm',
        s: {
          a: 0,
          k: 0,
          ix: 1
        },
        e: {
          a: 1,
          k: [{
            i: {
              x: [0],
              y: [1]
            },
            o: {
              x: [0.167],
              y: [0.167]
            },
            t: 22.8,
            s: [0]
          }, {
            t: 39.6,
            s: [100]
          }],
          ix: 2
        },
        o: {
          a: 0,
          k: 0,
          ix: 3
        },
        m: 1,
        ix: 4,
        nm: 'Trim Paths 1',
        mn: 'ADBE Vector Filter - Trim',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [0, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Shape 2',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [-11, 89.5], [0, 0]],
            o: [[0, 0], [34.5, -0.5], [0, 0]],
            v: [[-602.5, 78], [-522.5, -209], [-351, -211.5]],
            c: false
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'st',
        c: {
          a: 0,
          k: [1, 0, 0, 1],
          ix: 3
        },
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 87,
          ix: 5
        },
        lc: 1,
        lj: 1,
        ml: 4,
        bm: 0,
        nm: 'Stroke 1',
        mn: 'ADBE Vector Graphic - Stroke',
        hd: false
      }, {
        ty: 'tm',
        s: {
          a: 0,
          k: 0,
          ix: 1
        },
        e: {
          a: 1,
          k: [{
            i: {
              x: [0],
              y: [1]
            },
            o: {
              x: [0.167],
              y: [0.167]
            },
            t: 21.6,
            s: [0]
          }, {
            t: 39.6,
            s: [100]
          }],
          ix: 2
        },
        o: {
          a: 0,
          k: 0,
          ix: 3
        },
        m: 1,
        ix: 4,
        nm: 'Trim Paths 1',
        mn: 'ADBE Vector Filter - Trim',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [0, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Shape 1',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 2,
      mn: 'ADBE Vector Group',
      hd: false
    }],
    ip: 21.6,
    op: 60,
    st: 21.6,
    bm: 0
  }, {
    ddd: 0,
    ind: 3,
    ty: 4,
    nm: 'F-shape-white',
    tt: 1,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [264.885, 284.023, 0],
        ix: 2
      },
      a: {
        a: 0,
        k: [132.307, 160.443, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[-4.89, 0.265], [-4.441, 22.1], [37.063, -4.23], [-0.317, 1.19], [-5.261, 21.333], [-3.543, -0.027], [-32.726, -0.106], [-0.872, 2.881], [-5.499, 17.394], [-2.406, 7.745], [1.375, -0.08], [15.385, -1.111], [51.892, -3.648], [0.29, -2.802], [1.481, -10.019], [6.583, -37.247], [8.644, -42.957], [2.433, -10.097], [-0.555, 0], [-18.425, -0.131], [-0.767, 1.93], [-10.68, 35.529], [-3.199, 0.106], [-31.855, 1.137]],
            o: [[4.415, -21.941], [-37.38, 4.282], [0.344, -1.798], [5.393, -21.307], [0.846, -3.41], [32.752, 0.158], [2.908, 0], [5.367, -17.447], [2.326, -7.296], [-2.009, 0], [-15.412, 1.11], [-51.892, 3.727], [-2.934, 0.211], [-1.085, 10.072], [-5.551, 37.432], [-7.639, 43.142], [-2.036, 10.045], [0.82, 0.132], [18.452, 0.027], [2.749, 0.027], [13.825, -34.471], [0.845, -2.828], [31.881, -0.978], [4.969, -0.185]],
            v: [[80.614, 43.261], [93.779, -22.245], [-17.355, -9.503], [-16.535, -13.733], [-0.383, -77.627], [5.301, -82.041], [103.533, -81.883], [108.582, -85.504], [125.052, -137.74], [132.057, -160.104], [127.272, -160.104], [81.09, -156.747], [-74.587, -145.591], [-78.71, -141.626], [-82.438, -111.437], [-99.489, 0.78], [-124.866, 129.731], [-132.057, 159.787], [-130.127, 160.078], [-74.798, 160.157], [-70.806, 156.747], [-34.96, 51.456], [-29.779, 47.306], [65.811, 44.054]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [1, 1, 1, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [132.307, 160.434],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 2',
      np: 2,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }],
    ip: 21.6,
    op: 60,
    st: 21.6,
    bm: 0
  }, {
    ddd: 0,
    ind: 4,
    ty: 4,
    nm: 'Y-mask-white',
    parent: 5,
    td: 1,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [617.422, 251.42, 0],
        ix: 2
      },
      a: {
        a: 0,
        k: [0, 0, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [0, -32], [-18, 0], [-4, 23]],
            o: [[0, 0], [0, 32], [18, 0], [4, -23]],
            v: [[472, -111.5], [450, 9], [487.5, 47], [571.5, -105.5]],
            c: false
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'st',
        c: {
          a: 0,
          k: [1, 0, 0, 1],
          ix: 3
        },
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 78,
          ix: 5
        },
        lc: 1,
        lj: 1,
        ml: 4,
        bm: 0,
        nm: 'Stroke 1',
        mn: 'ADBE Vector Graphic - Stroke',
        hd: false
      }, {
        ty: 'tm',
        s: {
          a: 0,
          k: 0,
          ix: 1
        },
        e: {
          a: 1,
          k: [{
            i: {
              x: [0],
              y: [1]
            },
            o: {
              x: [0.333],
              y: [0]
            },
            t: 12,
            s: [0]
          }, {
            t: 26.400390625,
            s: [100]
          }],
          ix: 2
        },
        o: {
          a: 0,
          k: 0,
          ix: 3
        },
        m: 1,
        ix: 4,
        nm: 'Trim Paths 1',
        mn: 'ADBE Vector Filter - Trim',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [0, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Shape 2',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [0, 0], [82.5, 0], [10.5, 8.5]],
            o: [[0, 0], [0, 0], [-19, 0], [0, 0]],
            v: [[586.5, -105], [570.5, 22.5], [476.5, 130.5], [417, 105]],
            c: false
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'tm',
        s: {
          a: 0,
          k: 0,
          ix: 1
        },
        e: {
          a: 1,
          k: [{
            i: {
              x: [0],
              y: [1]
            },
            o: {
              x: [0.333],
              y: [0]
            },
            t: 12,
            s: [0]
          }, {
            t: 30,
            s: [100]
          }],
          ix: 2
        },
        o: {
          a: 0,
          k: 0,
          ix: 3
        },
        m: 1,
        ix: 2,
        nm: 'Trim Paths 1',
        mn: 'ADBE Vector Filter - Trim',
        hd: false
      }, {
        ty: 'st',
        c: {
          a: 0,
          k: [1, 0, 0, 1],
          ix: 3
        },
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 68,
          ix: 5
        },
        lc: 1,
        lj: 1,
        ml: 4,
        bm: 0,
        nm: 'Stroke 1',
        mn: 'ADBE Vector Graphic - Stroke',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [0, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Shape 1',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 2,
      mn: 'ADBE Vector Group',
      hd: false
    }],
    ip: 12,
    op: 60,
    st: 12,
    bm: 0
  }, {
    ddd: 0,
    ind: 5,
    ty: 4,
    nm: 'Y-shape-white',
    tt: 1,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [861.49, 350.26, 0],
        ix: 2
      },
      a: {
        a: 0,
        k: [728.912, 226.679, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[0, 1.189], [0.423, 0], [20.038, 0.079], [0.53, -2.221], [5.658, -21.967], [7.956, -11.605], [9.491, -0.131], [0.422, 10.204], [-1.296, 9.147], [-9.489, 23.025], [-0.555, 1.639], [21.729, -0.212], [0.475, -1.374], [3.701, -26.224], [0.553, -2.406], [-1.802, -8.994], [-0.185, -0.951], [-19.588, -3.912], [-9.676, 0.846], [-12.451, 14.486], [-3.912, 5.103], [16.654, -11.974], [17.5, 5.075], [7.983, 3.886], [11.658, -13.984], [-2.67, -2.512], [-24.902, -1.771], [-19.192, 12.293], [-8.988, 18.557], [-4.784, 29.474], [-5.366, 37.327]],
            o: [[-0.74, -0.159], [-20.038, -0.027], [-2.3, -0.027], [-5.287, 22.073], [-3.462, 13.403], [-5.076, 7.375], [-8.142, 0.133], [-0.398, -9.226], [3.463, -24.717], [0.503, -1.243], [-22.284, 0], [-1.19, 0], [-8.75, 24.982], [-0.37, 2.618], [-2.089, 9.088], [0.423, 1.797], [3.992, 19.298], [9.543, 1.904], [19.297, -1.719], [4.044, -4.733], [-3.701, 19.219], [-14.804, 10.627], [-7.905, -2.3], [-10.785, 12.927], [2.67, 3.04], [18.293, 17.235], [22.311, 1.586], [17.659, -11.34], [13.085, -27.123], [6.08, -37.221], [0.159, -1.189]],
            v: [[506.259, -75.988], [504.7, -76.304], [444.612, -76.384], [440.991, -73.317], [424.812, -7.203], [409.138, 31.022], [388.068, 43.816], [372.683, 26.925], [373.952, -0.833], [394.703, -72.155], [396.13, -76.358], [330.387, -76.198], [326.923, -72.974], [308.048, 3.793], [307.026, 11.407], [306.488, 54.365], [307.361, 58.064], [341.939, 94.439], [371.282, 95.946], [418.337, 69.724], [429.861, 54.734], [396.474, 110.194], [347.807, 119.553], [324.755, 108.582], [290.892, 149.16], [298.479, 157.699], [363.616, 185.72], [426.372, 171.312], [464.783, 125.131], [489.922, 39.588], [506.233, -72.339]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 3',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [1, 1, 1, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [728.11, 227.299],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 3',
      np: 2,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }],
    ip: 12,
    op: 60,
    st: 12,
    bm: 0
  }, {
    ddd: 0,
    ind: 6,
    ty: 4,
    nm: 'K-mask-white',
    td: 1,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [750, 375, 0],
        ix: 2
      },
      a: {
        a: 0,
        k: [0, 0, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [-37.75, 55.75], [-3.75, 0], [48.25, -40.75], [0, 0], [0, 0], [-31, 20], [0, 0]],
            o: [[0, 0], [17.247, -25.471], [3.75, 0], [-19.25, 15.25], [0, 0], [0, 0], [31, -20], [0, 0]],
            v: [[69.5, 72.75], [112, -57.5], [164.25, -85.25], [184, -47], [146.5, -22.5], [170.75, 30], [230.25, 37.75], [267.5, -13.25]],
            c: false
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'st',
        c: {
          a: 0,
          k: [1, 0, 0, 1],
          ix: 3
        },
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 78,
          ix: 5
        },
        lc: 1,
        lj: 1,
        ml: 4,
        bm: 0,
        nm: 'Stroke 1',
        mn: 'ADBE Vector Graphic - Stroke',
        hd: false
      }, {
        ty: 'tm',
        s: {
          a: 0,
          k: 0,
          ix: 1
        },
        e: {
          a: 1,
          k: [{
            i: {
              x: [0.833],
              y: [0.833]
            },
            o: {
              x: [0.167],
              y: [0.167]
            },
            t: 9.6,
            s: [0]
          }, {
            i: {
              x: [0.647],
              y: [0.642]
            },
            o: {
              x: [0.499],
              y: [0.132]
            },
            t: 12,
            s: [19]
          }, {
            i: {
              x: [0.574],
              y: [0.706]
            },
            o: {
              x: [0.259],
              y: [0.325]
            },
            t: 14.4,
            s: [55.787]
          }, {
            i: {
              x: [0.371],
              y: [1]
            },
            o: {
              x: [0.122],
              y: [0.597]
            },
            t: 15.6,
            s: [70.659]
          }, {
            t: 32.3998046875,
            s: [100]
          }],
          ix: 2
        },
        o: {
          a: 0,
          k: 0,
          ix: 3
        },
        m: 1,
        ix: 4,
        nm: 'Trim Paths 1',
        mn: 'ADBE Vector Filter - Trim',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [0, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Shape 2',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [-84, 191]],
            o: [[0, 0], [0, 0]],
            v: [[69, 72.5], [144.5, -228]],
            c: false
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'st',
        c: {
          a: 0,
          k: [1, 0, 0, 1],
          ix: 3
        },
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 78,
          ix: 5
        },
        lc: 1,
        lj: 1,
        ml: 4,
        bm: 0,
        nm: 'Stroke 1',
        mn: 'ADBE Vector Graphic - Stroke',
        hd: false
      }, {
        ty: 'tm',
        s: {
          a: 0,
          k: 0,
          ix: 1
        },
        e: {
          a: 1,
          k: [{
            i: {
              x: [0],
              y: [1]
            },
            o: {
              x: [0.167],
              y: [0.167]
            },
            t: 9.6,
            s: [17]
          }, {
            t: 27.6,
            s: [100]
          }],
          ix: 2
        },
        o: {
          a: 0,
          k: 0,
          ix: 3
        },
        m: 1,
        ix: 4,
        nm: 'Trim Paths 1',
        mn: 'ADBE Vector Filter - Trim',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [0, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Shape 1',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 2,
      mn: 'ADBE Vector Group',
      hd: false
    }],
    ip: 9.6,
    op: 60,
    st: 9.6,
    bm: 0
  }, {
    ddd: 0,
    ind: 7,
    ty: 4,
    nm: 'K-shape-white',
    tt: 1,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [861.49, 350.26, 0],
        ix: 2
      },
      a: {
        a: 0,
        k: [728.912, 226.679, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[2.511, -8.803], [2.406, -2.433], [16.707, -3.701], [-13.614, 9.331], [-3.251, 0.555]],
            o: [[-0.952, 3.277], [-11.842, 12.001], [7.349, -15.174], [2.722, -1.877], [8.962, -1.454]],
            v: [[66.537, -12.648], [61.276, -3.528], [17.236, 16.35], [45.257, -22.35], [54.641, -26.051]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 2',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ind: 1,
        ty: 'sh',
        ix: 2,
        ks: {
          a: 0,
          k: {
            i: [[25.283, -38.863], [3.754, -3.912], [7.402, -2.405], [5.446, 3.648], [3.225, 10.653], [-9.464, 9.728], [2.802, 19.007], [11.473, 5.102], [12.9, -4.045], [11.843, -15.2], [3.912, -5.604], [-20.884, 51.707], [6.742, 0], [7.454, -0.159], [2.882, 0], [7.719, 0.45], [10.599, -53.69], [3.542, -8.354], [2.906, -15.051], [0.951, -9.411], [0, 0], [-8.539, 21.861], [-0.396, -1.349], [-9.518, -13.297], [-25.511, 9.515], [-10.31, 12.134], [-4.256, 5.419]],
            o: [[-2.957, 4.545], [-5.26, 5.524], [-5.974, 1.931], [-9.385, -6.318], [12.768, -5.552], [12.69, -13.059], [-1.798, -12.107], [-12.663, -5.657], [-18.981, 5.948], [-4.203, 5.393], [14.539, -53.584], [-7.032, 0.106], [-7.454, 0], [-2.882, 0.053], [-7.692, 0], [-15.279, 52.527], [-1.798, 9.12], [-3.744, 13.953], [-1.031, 10.23], [0, 0], [3.147, -22.286], [0.581, 2.167], [4.442, 15.596], [16.256, 22.708], [15.147, -5.658], [4.362, -5.128], [20.999, -40.734]],
            v: [[140.528, 19.734], [129.982, 32.132], [111.213, 44.504], [93.951, 43.024], [76.689, 16.641], [110.076, -5.988], [128.053, -52.937], [109.046, -79.504], [70.556, -80.428], [26.065, -46.275], [14.249, -29.489], [67.701, -187.121], [46.736, -186.777], [24.348, -186.619], [15.703, -186.54], [-7.428, -187.307], [-46.313, -28.007], [-51.944, -0.833], [-61.595, 64.172], [-64.501, 93.012], [-2.353, 93.012], [13.351, 26.767], [14.698, 31.631], [34.605, 75.433], [101.036, 96.555], [138.176, 68.322], [150.812, 52.355]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 3',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [1, 1, 1, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [728.11, 227.299],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 3',
      np: 3,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }],
    ip: 9.6,
    op: 60,
    st: 9.6,
    bm: 0
  }, {
    ddd: 0,
    ind: 8,
    ty: 4,
    nm: 'U-mask-white',
    td: 1,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [750, 375, 0],
        ix: 2
      },
      a: {
        a: 0,
        k: [0, 0, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [3.5, -23.25], [-5.75, -11], [-11.75, 8.75], [-2.75, 12.25]],
            o: [[0, 0], [-3.5, 23.25], [5.75, 11], [11.75, -8.75], [2.75, -12.25]],
            v: [[-219, -110], [-241.5, -12.25], [-234, 34.25], [-190.75, 41.25], [-150.75, -28]],
            c: false
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'st',
        c: {
          a: 0,
          k: [1, 0, 0, 1],
          ix: 3
        },
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 75,
          ix: 5
        },
        lc: 1,
        lj: 1,
        ml: 4,
        bm: 0,
        nm: 'Stroke 1',
        mn: 'ADBE Vector Graphic - Stroke',
        hd: false
      }, {
        ty: 'tm',
        s: {
          a: 0,
          k: 0,
          ix: 1
        },
        e: {
          a: 1,
          k: [{
            i: {
              x: [0.623],
              y: [0.516]
            },
            o: {
              x: [0.664],
              y: [0]
            },
            t: 18,
            s: [0]
          }, {
            i: {
              x: [0.595],
              y: [0.796]
            },
            o: {
              x: [0.271],
              y: [0.217]
            },
            t: 22.8,
            s: [54.682]
          }, {
            i: {
              x: [0.44],
              y: [1]
            },
            o: {
              x: [0.159],
              y: [0.746]
            },
            t: 24,
            s: [76.576]
          }, {
            t: 36.000390625,
            s: [100]
          }],
          ix: 2
        },
        o: {
          a: 0,
          k: 0,
          ix: 3
        },
        m: 1,
        ix: 4,
        nm: 'Trim Paths 1',
        mn: 'ADBE Vector Filter - Trim',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [0, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Shape 2',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [0, -41], [-18.25, -9.5], [0, 0]],
            o: [[0, 0], [0, 29], [18, 13.75], [0, 0]],
            v: [[-334.5, -114.25], [-363, -3], [-335.75, 48.25], [-281, -23]],
            c: false
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'st',
        c: {
          a: 0,
          k: [1, 0, 0, 1],
          ix: 3
        },
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 75,
          ix: 5
        },
        lc: 1,
        lj: 1,
        ml: 4,
        bm: 0,
        nm: 'Stroke 1',
        mn: 'ADBE Vector Graphic - Stroke',
        hd: false
      }, {
        ty: 'tm',
        s: {
          a: 0,
          k: 0,
          ix: 1
        },
        e: {
          a: 1,
          k: [{
            i: {
              x: [0.623],
              y: [0.516]
            },
            o: {
              x: [0.664],
              y: [0]
            },
            t: 15.6,
            s: [0]
          }, {
            i: {
              x: [0.595],
              y: [0.828]
            },
            o: {
              x: [0.271],
              y: [0.183]
            },
            t: 20.4,
            s: [54.682]
          }, {
            i: {
              x: [0.44],
              y: [1]
            },
            o: {
              x: [0.159],
              y: [0.9]
            },
            t: 21.6,
            s: [80.576]
          }, {
            t: 33.6,
            s: [100]
          }],
          ix: 2
        },
        o: {
          a: 0,
          k: 0,
          ix: 3
        },
        m: 1,
        ix: 4,
        nm: 'Trim Paths 1',
        mn: 'ADBE Vector Filter - Trim',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [0, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Shape 1',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 2,
      mn: 'ADBE Vector Group',
      hd: false
    }],
    ip: 15.6,
    op: 60,
    st: 15.6,
    bm: 0
  }, {
    ddd: 0,
    ind: 9,
    ty: 4,
    nm: 'U-shape-white',
    tt: 1,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [861.49, 350.26, 0],
        ix: 2
      },
      a: {
        a: 0,
        k: [728.912, 226.679, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[9.343, -14.478], [7.534, -10.891], [5.075, -3.226], [2.459, 6.954], [-0.026, 5.578], [-6.926, 23.897], [-2.644, 8.353], [0.21, 0], [22.47, -0.158], [0.318, -1.189], [2.803, -11.657], [7.851, -18.187], [7.958, -5.261], [3.198, 16.019], [-0.767, 8.036], [-7.852, 21.359], [-2.141, 5.525], [0.423, 0], [21.174, 0.133], [0.608, -2.194], [4.071, -18.188], [-2.643, -23.897], [-8.009, -9.411], [-18.478, 6.609], [-10.362, 14.645], [-1.692, 2.38], [-0.687, -2.168], [-7.428, -6.53], [-18.266, 11.42], [-8.354, 10.653], [-0.793, 0.978], [-0.238, -0.159]],
            o: [[-5.816, 11.869], [-3.357, 4.891], [-6.24, 3.938], [-1.824, -5.26], [0.159, -25.087], [2.432, -8.46], [-0.529, -0.265], [-22.471, -0.053], [-1.084, 0], [-2.987, 11.605], [-4.573, 19.139], [-3.648, 8.432], [-9.305, 6.185], [-1.56, -7.798], [2.194, -22.734], [1.982, -5.419], [-0.873, -0.184], [-21.148, -0.026], [-2.908, 0], [-4.917, 18.029], [-5.154, 23.21], [1.322, 11.976], [14.355, 16.839], [17.289, -6.212], [1.349, -1.903], [0.845, 3.04], [2.961, 9.279], [14.724, 12.98], [11.579, -7.243], [0.793, -0.978], [0.238, 0.185], [15.406, -21.282]],
            v: [[-266.281, -1.651], [-286.821, 32.37], [-300.355, 44.558], [-315.688, 39.189], [-318.464, 22.51], [-305.405, -50.609], [-297.5, -75.775], [-298.478, -76.278], [-365.862, -76.225], [-369.008, -73.397], [-377.573, -38.476], [-393.989, 18.175], [-409.93, 40.011], [-436.708, 30.334], [-437.131, 6.094], [-420.397, -59.703], [-414.053, -76.015], [-415.745, -76.332], [-479.242, -76.437], [-483.472, -72.736], [-498.117, -18.676], [-503.748, 51.985], [-490.742, 84.447], [-427.747, 96.871], [-387.645, 63.986], [-383.256, 57.827], [-381.142, 65.229], [-366.179, 89.258], [-306.78, 92.668], [-277.489, 65.334], [-275.057, 62.401], [-274.344, 62.902]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 3',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [1, 1, 1, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [728.11, 227.299],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 3',
      np: 2,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }],
    ip: 15.6,
    op: 60,
    st: 15.6,
    bm: 0
  }, {
    ddd: 0,
    ind: 10,
    ty: 4,
    nm: 'N-mask-white',
    td: 1,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [750, 375, 0],
        ix: 2
      },
      a: {
        a: 0,
        k: [0, 0, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [-22, 36.75], [-16, 0], [12.25, -49.75], [0, 0], [-48.25, 0], [0, 0]],
            o: [[0, 0], [24.453, -40.848], [16, 0], [-10.25, 37.25], [0, 0], [48.25, 0], [0, 0]],
            v: [[-141.25, 75.25], [-107.75, -45], [-44, -79.25], [-6.5, -37], [-18.75, 12.25], [10.25, 47.25], [65, -29.25]],
            c: false
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'st',
        c: {
          a: 0,
          k: [1, 0, 0, 1],
          ix: 3
        },
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 75,
          ix: 5
        },
        lc: 1,
        lj: 1,
        ml: 4,
        bm: 0,
        nm: 'Stroke 1',
        mn: 'ADBE Vector Graphic - Stroke',
        hd: false
      }, {
        ty: 'tm',
        s: {
          a: 0,
          k: 0,
          ix: 1
        },
        e: {
          a: 1,
          k: [{
            i: {
              x: [0.468],
              y: [0.43]
            },
            o: {
              x: [0.627],
              y: [0]
            },
            t: 12,
            s: [0]
          }, {
            i: {
              x: [0.626],
              y: [0.831]
            },
            o: {
              x: [0.295],
              y: [0.183]
            },
            t: 21.6,
            s: [68.576]
          }, {
            i: {
              x: [0.484],
              y: [1]
            },
            o: {
              x: [0.185],
              y: [0.822]
            },
            t: 22.8,
            s: [83.423]
          }, {
            t: 36,
            s: [100]
          }],
          ix: 2
        },
        o: {
          a: 0,
          k: 0,
          ix: 3
        },
        m: 1,
        ix: 4,
        nm: 'Trim Paths 1',
        mn: 'ADBE Vector Filter - Trim',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [0, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Shape 2',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [-30, 105]],
            o: [[0, 0], [13.079, -45.777]],
            v: [[-141.25, 75.25], [-113.25, -110.25]],
            c: false
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'st',
        c: {
          a: 0,
          k: [1, 0, 0, 1],
          ix: 3
        },
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 75,
          ix: 5
        },
        lc: 1,
        lj: 1,
        ml: 4,
        bm: 0,
        nm: 'Stroke 1',
        mn: 'ADBE Vector Graphic - Stroke',
        hd: false
      }, {
        ty: 'tm',
        s: {
          a: 0,
          k: 0,
          ix: 1
        },
        e: {
          a: 1,
          k: [{
            i: {
              x: [0],
              y: [1]
            },
            o: {
              x: [0.333],
              y: [0]
            },
            t: 12,
            s: [0]
          }, {
            t: 19.2001953125,
            s: [100]
          }],
          ix: 2
        },
        o: {
          a: 0,
          k: 0,
          ix: 3
        },
        m: 1,
        ix: 4,
        nm: 'Trim Paths 1',
        mn: 'ADBE Vector Filter - Trim',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [0, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Shape 1',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 2,
      mn: 'ADBE Vector Group',
      hd: false
    }],
    ip: 12,
    op: 60,
    st: 12,
    bm: 0
  }, {
    ddd: 0,
    ind: 11,
    ty: 4,
    nm: 'N-shape-white',
    tt: 1,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [699.449, 359.394, 0],
        ix: 2
      },
      a: {
        a: 0,
        k: [566.87, 235.814, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[10.756, -21.797], [11.395, -11.103], [4.15, -1.533], [-0.581, 8.142], [-1.084, 2.881], [-3.252, 7.745], [2.142, 18.795], [14.909, 3.331], [15.888, -11.209], [9.067, -14.222], [0.925, -1.242], [0.423, 0.238], [-3.728, 15.385], [0, 0], [3.648, -17.606], [3.146, -6.424], [-0.238, -0.159], [0.899, -10.204], [0, 0], [-0.106, 0.819], [-7.64, 21.042], [-10.653, 11.896], [-4.758, 2.247], [-0.74, -7.56], [0.37, -1.506], [2.671, -9.146], [0.186, -13.904], [-14.962, -8.485], [-13.535, 3.014], [-10.283, 11.261], [-3.515, 4.071]],
            o: [[-6.134, 14.46], [-3.171, 3.093], [-7.773, 2.909], [0.212, -3.093], [2.935, -7.878], [7.058, -16.813], [-1.744, -15.2], [-19.43, -4.335], [-13.878, 9.781], [-0.82, 1.295], [-0.423, -0.212], [3.727, -15.253], [0, 0], [-3.675, 17.685], [-1.481, 7.243], [-2.157, 11.772], [-0.872, 9.94], [0, 0], [0.185, -0.977], [2.405, -22.231], [5.366, -14.83], [3.516, -3.939], [6.82, -3.225], [0.159, 1.534], [-2.221, 9.279], [-3.885, 13.166], [-0.211, 16.576], [12.187, 6.926], [15.253, -3.382], [2.986, -3.278], [18.156, -27.801]],
            v: [[-51.944, -0.833], [-77.852, 38.213], [-89.244, 45.481], [-103.414, 34.75], [-101.59, 25.577], [-92.152, 2.182], [-81.288, -50.398], [-109.256, -81.856], [-161.968, -70.33], [-195.408, -33.348], [-198.131, -29.62], [-199.4, -30.281], [-188.244, -76.172], [-250.71, -76.172], [-261.707, -23.302], [-266.281, -1.651], [-274.344, 62.902], [-277.014, 92.986], [-215.023, 92.986], [-214.547, 90.368], [-199.981, 25.339], [-177.697, -15.822], [-164.902, -25.496], [-152.055, -17.46], [-152.266, -12.781], [-159.219, 14.975], [-167.44, 55.104], [-147.27, 94.043], [-108.172, 98.853], [-70.951, 74.931], [-61.594, 64.172]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 3',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [1, 1, 1, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [728.11, 227.299],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 3',
      np: 2,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }],
    ip: 12,
    op: 60,
    st: 12,
    bm: 0
  }, {
    ddd: 0,
    ind: 12,
    ty: 4,
    nm: 'E-mask-white',
    td: 1,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [1107.097, 354.625, 0],
        ix: 2
      },
      a: {
        a: 0,
        k: [357.097, -20.375, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [41.75, 0], [2.5, 34.25], [-33.75, 0], [0, -11.25], [15.5, -3.75]],
            o: [[0, 0], [-41.75, 0], [-1.75, -23.969], [33.75, 0], [0, 11.25], [-15.5, 3.75]],
            v: [[427, -14.75], [353.25, 52.75], [287.25, -9], [358.5, -93.5], [387.5, -56.5], [318.75, -5.5]],
            c: false
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'st',
        c: {
          a: 0,
          k: [1, 0, 0, 1],
          ix: 3
        },
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 69,
          ix: 5
        },
        lc: 1,
        lj: 1,
        ml: 4,
        bm: 0,
        nm: 'Stroke 1',
        mn: 'ADBE Vector Graphic - Stroke',
        hd: false
      }, {
        ty: 'tm',
        s: {
          a: 0,
          k: 0,
          ix: 1
        },
        e: {
          a: 1,
          k: [{
            i: {
              x: [0.468],
              y: [0.572]
            },
            o: {
              x: [0.627],
              y: [0]
            },
            t: 4.8,
            s: [0]
          }, {
            i: {
              x: [0.619],
              y: [0.831]
            },
            o: {
              x: [0.289],
              y: [0.186]
            },
            t: 10.8,
            s: [68.576]
          }, {
            i: {
              x: [0.491],
              y: [1]
            },
            o: {
              x: [0.189],
              y: [0.907]
            },
            t: 12,
            s: [85.727]
          }, {
            t: 22.8,
            s: [100]
          }],
          ix: 2
        },
        o: {
          a: 0,
          k: 0,
          ix: 3
        },
        m: 1,
        ix: 4,
        nm: 'Trim Paths 1',
        mn: 'ADBE Vector Filter - Trim',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [0, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Shape 1',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }],
    ip: 4.8,
    op: 60,
    st: 4.8,
    bm: 0
  }, {
    ddd: 0,
    ind: 13,
    ty: 4,
    nm: 'E-shape-white',
    tt: 1,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [861.49, 350.26, 0],
        ix: 2
      },
      a: {
        a: 0,
        k: [728.912, 226.679, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[-9.041, 11.367], [-5.737, 1.585], [-0.634, -6.529], [5.657, -6.397], [12.319, -3.754]],
            o: [[3.596, -4.547], [6.344, -1.772], [0.873, 8.777], [-8.247, 9.332], [1.005, -14.91]],
            v: [[227.501, -34.67], [241.141, -44.476], [253.301, -36.282], [245.345, -13.574], [214.099, 4.931]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ind: 1,
        ty: 'sh',
        ix: 2,
        ks: {
          a: 0,
          k: {
            i: [[1.506, -1.957], [7.692, -7.561], [16.945, 1.084], [2.115, 12.451], [-1.507, 0.343], [-12.028, 7.64], [-3.596, 22.39], [19.773, 6.741], [19.642, -8.221], [9.597, -30.216], [2.097, -5.848], [-2.501, -9.484], [-10.89, -7.349], [-28.312, 11.34], [-12.874, 14.672], [-1.375, 1.532]],
            o: [[-6.662, 8.564], [-11.526, 11.34], [-13.006, -0.846], [1.454, -0.397], [13.879, -3.173], [18.267, -11.579], [3.33, -20.673], [-20.594, -7.006], [-30.057, 12.583], [-1.878, 5.933], [-2.576, 9.402], [7.428, 17.712], [26.119, 17.606], [18.293, -7.349], [0.951, -1.084], [23.823, -40.244]],
            v: [[305.776, 11.407], [284.997, 36.389], [242.727, 53.756], [216.557, 31.102], [220.997, 29.886], [260.068, 13.998], [295.599, -35.012], [269.374, -79.397], [208.705, -76.304], [151.922, -9.344], [147.012, 8.719], [150.812, 52.355], [175.397, 86.403], [257.531, 92.774], [303.185, 58.064], [306.488, 54.365]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 3',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [1, 1, 1, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [728.11, 227.299],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 3',
      np: 3,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }],
    ip: 4.8,
    op: 60,
    st: 4.8,
    bm: 0
  }, {
    ddd: 0,
    ind: 14,
    ty: 4,
    nm: 'F-mask-salmon',
    td: 1,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [750, 375, 0],
        ix: 2
      },
      a: {
        a: 0,
        k: [0, 0, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [0, 0]],
            o: [[0, 0], [0, 0]],
            v: [[-524, -69.75], [-388.25, -81.25]],
            c: false
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'st',
        c: {
          a: 0,
          k: [1, 0, 0, 1],
          ix: 3
        },
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 64,
          ix: 5
        },
        lc: 1,
        lj: 1,
        ml: 4,
        bm: 0,
        nm: 'Stroke 1',
        mn: 'ADBE Vector Graphic - Stroke',
        hd: false
      }, {
        ty: 'tm',
        s: {
          a: 0,
          k: 0,
          ix: 1
        },
        e: {
          a: 1,
          k: [{
            i: {
              x: [0],
              y: [1]
            },
            o: {
              x: [0.167],
              y: [0.167]
            },
            t: 18,
            s: [0]
          }, {
            t: 34.8,
            s: [100]
          }],
          ix: 2
        },
        o: {
          a: 0,
          k: 0,
          ix: 3
        },
        m: 1,
        ix: 4,
        nm: 'Trim Paths 1',
        mn: 'ADBE Vector Filter - Trim',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [0, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Shape 2',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [-11, 89.5], [0, 0]],
            o: [[0, 0], [34.5, -0.5], [0, 0]],
            v: [[-602.5, 78], [-522.5, -209], [-351, -211.5]],
            c: false
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'st',
        c: {
          a: 0,
          k: [1, 0, 0, 1],
          ix: 3
        },
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 87,
          ix: 5
        },
        lc: 1,
        lj: 1,
        ml: 4,
        bm: 0,
        nm: 'Stroke 1',
        mn: 'ADBE Vector Graphic - Stroke',
        hd: false
      }, {
        ty: 'tm',
        s: {
          a: 0,
          k: 0,
          ix: 1
        },
        e: {
          a: 1,
          k: [{
            i: {
              x: [0],
              y: [1]
            },
            o: {
              x: [0.167],
              y: [0.167]
            },
            t: 16.8,
            s: [0]
          }, {
            t: 34.8,
            s: [100]
          }],
          ix: 2
        },
        o: {
          a: 0,
          k: 0,
          ix: 3
        },
        m: 1,
        ix: 4,
        nm: 'Trim Paths 1',
        mn: 'ADBE Vector Filter - Trim',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [0, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Shape 1',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 2,
      mn: 'ADBE Vector Group',
      hd: false
    }],
    ip: 16.8,
    op: 60,
    st: 16.8,
    bm: 0
  }, {
    ddd: 0,
    ind: 15,
    ty: 4,
    nm: 'F-shape-salmon',
    tt: 1,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [264.885, 284.023, 0],
        ix: 2
      },
      a: {
        a: 0,
        k: [132.307, 160.443, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[-4.89, 0.265], [-4.441, 22.1], [37.063, -4.23], [-0.317, 1.19], [-5.261, 21.333], [-3.543, -0.027], [-32.726, -0.106], [-0.872, 2.881], [-5.499, 17.394], [-2.406, 7.745], [1.375, -0.08], [15.385, -1.111], [51.892, -3.648], [0.29, -2.802], [1.481, -10.019], [6.583, -37.247], [8.644, -42.957], [2.433, -10.097], [-0.555, 0], [-18.425, -0.131], [-0.767, 1.93], [-10.68, 35.529], [-3.199, 0.106], [-31.855, 1.137]],
            o: [[4.415, -21.941], [-37.38, 4.282], [0.344, -1.798], [5.393, -21.307], [0.846, -3.41], [32.752, 0.158], [2.908, 0], [5.367, -17.447], [2.326, -7.296], [-2.009, 0], [-15.412, 1.11], [-51.892, 3.727], [-2.934, 0.211], [-1.085, 10.072], [-5.551, 37.432], [-7.639, 43.142], [-2.036, 10.045], [0.82, 0.132], [18.452, 0.027], [2.749, 0.027], [13.825, -34.471], [0.845, -2.828], [31.881, -0.978], [4.969, -0.185]],
            v: [[80.614, 43.261], [93.779, -22.245], [-17.355, -9.503], [-16.535, -13.733], [-0.383, -77.627], [5.301, -82.041], [103.533, -81.883], [108.582, -85.504], [125.052, -137.74], [132.057, -160.104], [127.272, -160.104], [81.09, -156.747], [-74.587, -145.591], [-78.71, -141.626], [-82.438, -111.437], [-99.489, 0.78], [-124.866, 129.731], [-132.057, 159.787], [-130.127, 160.078], [-74.798, 160.157], [-70.806, 156.747], [-34.96, 51.456], [-29.779, 47.306], [65.811, 44.054]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [0.945098099054, 0.380392186782, 0.317647058824, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [132.307, 160.434],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 2',
      np: 2,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }],
    ip: 16.8,
    op: 60,
    st: 16.8,
    bm: 0
  }, {
    ddd: 0,
    ind: 16,
    ty: 4,
    nm: 'Y-mask-turqoise',
    parent: 17,
    td: 1,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [617.422, 251.42, 0],
        ix: 2
      },
      a: {
        a: 0,
        k: [0, 0, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [0, -32], [-18, 0], [-4, 23]],
            o: [[0, 0], [0, 32], [18, 0], [4, -23]],
            v: [[472, -111.5], [450, 9], [487.5, 47], [571.5, -105.5]],
            c: false
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'st',
        c: {
          a: 0,
          k: [1, 0, 0, 1],
          ix: 3
        },
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 78,
          ix: 5
        },
        lc: 1,
        lj: 1,
        ml: 4,
        bm: 0,
        nm: 'Stroke 1',
        mn: 'ADBE Vector Graphic - Stroke',
        hd: false
      }, {
        ty: 'tm',
        s: {
          a: 0,
          k: 0,
          ix: 1
        },
        e: {
          a: 1,
          k: [{
            i: {
              x: [0],
              y: [1]
            },
            o: {
              x: [0.333],
              y: [0]
            },
            t: 7.2,
            s: [0]
          }, {
            t: 21.600390625,
            s: [100]
          }],
          ix: 2
        },
        o: {
          a: 0,
          k: 0,
          ix: 3
        },
        m: 1,
        ix: 4,
        nm: 'Trim Paths 1',
        mn: 'ADBE Vector Filter - Trim',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [0, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Shape 2',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [0, 0], [82.5, 0], [10.5, 8.5]],
            o: [[0, 0], [0, 0], [-19, 0], [0, 0]],
            v: [[586.5, -105], [570.5, 22.5], [476.5, 130.5], [417, 105]],
            c: false
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'tm',
        s: {
          a: 0,
          k: 0,
          ix: 1
        },
        e: {
          a: 1,
          k: [{
            i: {
              x: [0],
              y: [1]
            },
            o: {
              x: [0.333],
              y: [0]
            },
            t: 7.2,
            s: [0]
          }, {
            t: 25.2,
            s: [100]
          }],
          ix: 2
        },
        o: {
          a: 0,
          k: 0,
          ix: 3
        },
        m: 1,
        ix: 2,
        nm: 'Trim Paths 1',
        mn: 'ADBE Vector Filter - Trim',
        hd: false
      }, {
        ty: 'st',
        c: {
          a: 0,
          k: [1, 0, 0, 1],
          ix: 3
        },
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 68,
          ix: 5
        },
        lc: 1,
        lj: 1,
        ml: 4,
        bm: 0,
        nm: 'Stroke 1',
        mn: 'ADBE Vector Graphic - Stroke',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [0, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Shape 1',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 2,
      mn: 'ADBE Vector Group',
      hd: false
    }],
    ip: 7.2,
    op: 60,
    st: 7.2,
    bm: 0
  }, {
    ddd: 0,
    ind: 17,
    ty: 4,
    nm: 'Y-shape-turqoise',
    tt: 1,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [861.49, 350.26, 0],
        ix: 2
      },
      a: {
        a: 0,
        k: [728.912, 226.679, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[0, 1.189], [0.423, 0], [20.038, 0.079], [0.53, -2.221], [5.658, -21.967], [7.956, -11.605], [9.491, -0.131], [0.422, 10.204], [-1.296, 9.147], [-9.489, 23.025], [-0.555, 1.639], [21.729, -0.212], [0.475, -1.374], [3.701, -26.224], [0.553, -2.406], [-1.802, -8.994], [-0.185, -0.951], [-19.588, -3.912], [-9.676, 0.846], [-12.451, 14.486], [-3.912, 5.103], [16.654, -11.974], [17.5, 5.075], [7.983, 3.886], [11.658, -13.984], [-2.67, -2.512], [-24.902, -1.771], [-19.192, 12.293], [-8.988, 18.557], [-4.784, 29.474], [-5.366, 37.327]],
            o: [[-0.74, -0.159], [-20.038, -0.027], [-2.3, -0.027], [-5.287, 22.073], [-3.462, 13.403], [-5.076, 7.375], [-8.142, 0.133], [-0.398, -9.226], [3.463, -24.717], [0.503, -1.243], [-22.284, 0], [-1.19, 0], [-8.75, 24.982], [-0.37, 2.618], [-2.089, 9.088], [0.423, 1.797], [3.992, 19.298], [9.543, 1.904], [19.297, -1.719], [4.044, -4.733], [-3.701, 19.219], [-14.804, 10.627], [-7.905, -2.3], [-10.785, 12.927], [2.67, 3.04], [18.293, 17.235], [22.311, 1.586], [17.659, -11.34], [13.085, -27.123], [6.08, -37.221], [0.159, -1.189]],
            v: [[506.259, -75.988], [504.7, -76.304], [444.612, -76.384], [440.991, -73.317], [424.812, -7.203], [409.138, 31.022], [388.068, 43.816], [372.683, 26.925], [373.952, -0.833], [394.703, -72.155], [396.13, -76.358], [330.387, -76.198], [326.923, -72.974], [308.048, 3.793], [307.026, 11.407], [306.488, 54.365], [307.361, 58.064], [341.939, 94.439], [371.282, 95.946], [418.337, 69.724], [429.861, 54.734], [396.474, 110.194], [347.807, 119.553], [324.755, 108.582], [290.892, 149.16], [298.479, 157.699], [363.616, 185.72], [426.372, 171.312], [464.783, 125.131], [489.922, 39.588], [506.233, -72.339]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 3',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [0.274509803922, 0.729411764706, 0.607843137255, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [728.11, 227.299],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 3',
      np: 2,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }],
    ip: 7.2,
    op: 60,
    st: 7.2,
    bm: 0
  }, {
    ddd: 0,
    ind: 18,
    ty: 4,
    nm: 'K-mask-yellow',
    td: 1,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [750, 375, 0],
        ix: 2
      },
      a: {
        a: 0,
        k: [0, 0, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [-37.75, 55.75], [-3.75, 0], [48.25, -40.75], [0, 0], [0, 0], [-31, 20], [0, 0]],
            o: [[0, 0], [17.247, -25.471], [3.75, 0], [-19.25, 15.25], [0, 0], [0, 0], [31, -20], [0, 0]],
            v: [[69.5, 72.75], [112, -57.5], [164.25, -85.25], [184, -47], [146.5, -22.5], [170.75, 30], [230.25, 37.75], [267.5, -13.25]],
            c: false
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'st',
        c: {
          a: 0,
          k: [1, 0, 0, 1],
          ix: 3
        },
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 78,
          ix: 5
        },
        lc: 1,
        lj: 1,
        ml: 4,
        bm: 0,
        nm: 'Stroke 1',
        mn: 'ADBE Vector Graphic - Stroke',
        hd: false
      }, {
        ty: 'tm',
        s: {
          a: 0,
          k: 0,
          ix: 1
        },
        e: {
          a: 1,
          k: [{
            i: {
              x: [0.833],
              y: [0.833]
            },
            o: {
              x: [0.167],
              y: [0.167]
            },
            t: 4.8,
            s: [0]
          }, {
            i: {
              x: [0.647],
              y: [0.642]
            },
            o: {
              x: [0.499],
              y: [0.132]
            },
            t: 7.2,
            s: [19]
          }, {
            i: {
              x: [0.574],
              y: [0.706]
            },
            o: {
              x: [0.259],
              y: [0.325]
            },
            t: 9.6,
            s: [55.787]
          }, {
            i: {
              x: [0.371],
              y: [1]
            },
            o: {
              x: [0.122],
              y: [0.597]
            },
            t: 10.8,
            s: [70.659]
          }, {
            t: 27.5998046875,
            s: [100]
          }],
          ix: 2
        },
        o: {
          a: 0,
          k: 0,
          ix: 3
        },
        m: 1,
        ix: 4,
        nm: 'Trim Paths 1',
        mn: 'ADBE Vector Filter - Trim',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [0, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Shape 2',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [-84, 191]],
            o: [[0, 0], [0, 0]],
            v: [[69, 72.5], [144.5, -228]],
            c: false
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'st',
        c: {
          a: 0,
          k: [1, 0, 0, 1],
          ix: 3
        },
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 78,
          ix: 5
        },
        lc: 1,
        lj: 1,
        ml: 4,
        bm: 0,
        nm: 'Stroke 1',
        mn: 'ADBE Vector Graphic - Stroke',
        hd: false
      }, {
        ty: 'tm',
        s: {
          a: 0,
          k: 0,
          ix: 1
        },
        e: {
          a: 1,
          k: [{
            i: {
              x: [0],
              y: [1]
            },
            o: {
              x: [0.167],
              y: [0.167]
            },
            t: 4.8,
            s: [17]
          }, {
            t: 22.8,
            s: [100]
          }],
          ix: 2
        },
        o: {
          a: 0,
          k: 0,
          ix: 3
        },
        m: 1,
        ix: 4,
        nm: 'Trim Paths 1',
        mn: 'ADBE Vector Filter - Trim',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [0, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Shape 1',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 2,
      mn: 'ADBE Vector Group',
      hd: false
    }],
    ip: 4.8,
    op: 60,
    st: 4.8,
    bm: 0
  }, {
    ddd: 0,
    ind: 19,
    ty: 4,
    nm: 'K-shape-yellow',
    tt: 1,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [861.49, 350.26, 0],
        ix: 2
      },
      a: {
        a: 0,
        k: [728.912, 226.679, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[2.511, -8.803], [2.406, -2.433], [16.707, -3.701], [-13.614, 9.331], [-3.251, 0.555]],
            o: [[-0.952, 3.277], [-11.842, 12.001], [7.349, -15.174], [2.722, -1.877], [8.962, -1.454]],
            v: [[66.537, -12.648], [61.276, -3.528], [17.236, 16.35], [45.257, -22.35], [54.641, -26.051]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 2',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ind: 1,
        ty: 'sh',
        ix: 2,
        ks: {
          a: 0,
          k: {
            i: [[25.283, -38.863], [3.754, -3.912], [7.402, -2.405], [5.446, 3.648], [3.225, 10.653], [-9.464, 9.728], [2.802, 19.007], [11.473, 5.102], [12.9, -4.045], [11.843, -15.2], [3.912, -5.604], [-20.884, 51.707], [6.742, 0], [7.454, -0.159], [2.882, 0], [7.719, 0.45], [10.599, -53.69], [3.542, -8.354], [2.906, -15.051], [0.951, -9.411], [0, 0], [-8.539, 21.861], [-0.396, -1.349], [-9.518, -13.297], [-25.511, 9.515], [-10.31, 12.134], [-4.256, 5.419]],
            o: [[-2.957, 4.545], [-5.26, 5.524], [-5.974, 1.931], [-9.385, -6.318], [12.768, -5.552], [12.69, -13.059], [-1.798, -12.107], [-12.663, -5.657], [-18.981, 5.948], [-4.203, 5.393], [14.539, -53.584], [-7.032, 0.106], [-7.454, 0], [-2.882, 0.053], [-7.692, 0], [-15.279, 52.527], [-1.798, 9.12], [-3.744, 13.953], [-1.031, 10.23], [0, 0], [3.147, -22.286], [0.581, 2.167], [4.442, 15.596], [16.256, 22.708], [15.147, -5.658], [4.362, -5.128], [20.999, -40.734]],
            v: [[140.528, 19.734], [129.982, 32.132], [111.213, 44.504], [93.951, 43.024], [76.689, 16.641], [110.076, -5.988], [128.053, -52.937], [109.046, -79.504], [70.556, -80.428], [26.065, -46.275], [14.249, -29.489], [67.701, -187.121], [46.736, -186.777], [24.348, -186.619], [15.703, -186.54], [-7.428, -187.307], [-46.313, -28.007], [-51.944, -0.833], [-61.595, 64.172], [-64.501, 93.012], [-2.353, 93.012], [13.351, 26.767], [14.698, 31.631], [34.605, 75.433], [101.036, 96.555], [138.176, 68.322], [150.812, 52.355]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 3',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [0.984313785329, 0.686274509804, 0.266666666667, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [728.11, 227.299],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 3',
      np: 3,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }],
    ip: 4.8,
    op: 60,
    st: 4.8,
    bm: 0
  }, {
    ddd: 0,
    ind: 20,
    ty: 4,
    nm: 'U-mask-yellow',
    td: 1,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [750, 375, 0],
        ix: 2
      },
      a: {
        a: 0,
        k: [0, 0, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [3.5, -23.25], [-5.75, -11], [-11.75, 8.75], [-2.75, 12.25]],
            o: [[0, 0], [-3.5, 23.25], [5.75, 11], [11.75, -8.75], [2.75, -12.25]],
            v: [[-219, -110], [-241.5, -12.25], [-234, 34.25], [-190.75, 41.25], [-150.75, -28]],
            c: false
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'st',
        c: {
          a: 0,
          k: [1, 0, 0, 1],
          ix: 3
        },
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 75,
          ix: 5
        },
        lc: 1,
        lj: 1,
        ml: 4,
        bm: 0,
        nm: 'Stroke 1',
        mn: 'ADBE Vector Graphic - Stroke',
        hd: false
      }, {
        ty: 'tm',
        s: {
          a: 0,
          k: 0,
          ix: 1
        },
        e: {
          a: 1,
          k: [{
            i: {
              x: [0.623],
              y: [0.516]
            },
            o: {
              x: [0.664],
              y: [0]
            },
            t: 13.2,
            s: [0]
          }, {
            i: {
              x: [0.595],
              y: [0.796]
            },
            o: {
              x: [0.271],
              y: [0.217]
            },
            t: 18,
            s: [54.682]
          }, {
            i: {
              x: [0.44],
              y: [1]
            },
            o: {
              x: [0.159],
              y: [0.746]
            },
            t: 19.2,
            s: [76.576]
          }, {
            t: 31.200390625,
            s: [100]
          }],
          ix: 2
        },
        o: {
          a: 0,
          k: 0,
          ix: 3
        },
        m: 1,
        ix: 4,
        nm: 'Trim Paths 1',
        mn: 'ADBE Vector Filter - Trim',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [0, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Shape 2',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [0, -41], [-18.25, -9.5], [0, 0]],
            o: [[0, 0], [0, 29], [18, 13.75], [0, 0]],
            v: [[-334.5, -114.25], [-363, -3], [-335.75, 48.25], [-281, -23]],
            c: false
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'st',
        c: {
          a: 0,
          k: [1, 0, 0, 1],
          ix: 3
        },
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 75,
          ix: 5
        },
        lc: 1,
        lj: 1,
        ml: 4,
        bm: 0,
        nm: 'Stroke 1',
        mn: 'ADBE Vector Graphic - Stroke',
        hd: false
      }, {
        ty: 'tm',
        s: {
          a: 0,
          k: 0,
          ix: 1
        },
        e: {
          a: 1,
          k: [{
            i: {
              x: [0.623],
              y: [0.516]
            },
            o: {
              x: [0.664],
              y: [0]
            },
            t: 10.8,
            s: [0]
          }, {
            i: {
              x: [0.595],
              y: [0.828]
            },
            o: {
              x: [0.271],
              y: [0.183]
            },
            t: 15.6,
            s: [54.682]
          }, {
            i: {
              x: [0.44],
              y: [1]
            },
            o: {
              x: [0.159],
              y: [0.9]
            },
            t: 16.8,
            s: [80.576]
          }, {
            t: 28.8,
            s: [100]
          }],
          ix: 2
        },
        o: {
          a: 0,
          k: 0,
          ix: 3
        },
        m: 1,
        ix: 4,
        nm: 'Trim Paths 1',
        mn: 'ADBE Vector Filter - Trim',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [0, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Shape 1',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 2,
      mn: 'ADBE Vector Group',
      hd: false
    }],
    ip: 10.8,
    op: 60,
    st: 10.8,
    bm: 0
  }, {
    ddd: 0,
    ind: 21,
    ty: 4,
    nm: 'U-shape-yellow',
    tt: 1,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [861.49, 350.26, 0],
        ix: 2
      },
      a: {
        a: 0,
        k: [728.912, 226.679, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[9.343, -14.478], [7.534, -10.891], [5.075, -3.226], [2.459, 6.954], [-0.026, 5.578], [-6.926, 23.897], [-2.644, 8.353], [0.21, 0], [22.47, -0.158], [0.318, -1.189], [2.803, -11.657], [7.851, -18.187], [7.958, -5.261], [3.198, 16.019], [-0.767, 8.036], [-7.852, 21.359], [-2.141, 5.525], [0.423, 0], [21.174, 0.133], [0.608, -2.194], [4.071, -18.188], [-2.643, -23.897], [-8.009, -9.411], [-18.478, 6.609], [-10.362, 14.645], [-1.692, 2.38], [-0.687, -2.168], [-7.428, -6.53], [-18.266, 11.42], [-8.354, 10.653], [-0.793, 0.978], [-0.238, -0.159]],
            o: [[-5.816, 11.869], [-3.357, 4.891], [-6.24, 3.938], [-1.824, -5.26], [0.159, -25.087], [2.432, -8.46], [-0.529, -0.265], [-22.471, -0.053], [-1.084, 0], [-2.987, 11.605], [-4.573, 19.139], [-3.648, 8.432], [-9.305, 6.185], [-1.56, -7.798], [2.194, -22.734], [1.982, -5.419], [-0.873, -0.184], [-21.148, -0.026], [-2.908, 0], [-4.917, 18.029], [-5.154, 23.21], [1.322, 11.976], [14.355, 16.839], [17.289, -6.212], [1.349, -1.903], [0.845, 3.04], [2.961, 9.279], [14.724, 12.98], [11.579, -7.243], [0.793, -0.978], [0.238, 0.185], [15.406, -21.282]],
            v: [[-266.281, -1.651], [-286.821, 32.37], [-300.355, 44.558], [-315.688, 39.189], [-318.464, 22.51], [-305.405, -50.609], [-297.5, -75.775], [-298.478, -76.278], [-365.862, -76.225], [-369.008, -73.397], [-377.573, -38.476], [-393.989, 18.175], [-409.93, 40.011], [-436.708, 30.334], [-437.131, 6.094], [-420.397, -59.703], [-414.053, -76.015], [-415.745, -76.332], [-479.242, -76.437], [-483.472, -72.736], [-498.117, -18.676], [-503.748, 51.985], [-490.742, 84.447], [-427.747, 96.871], [-387.645, 63.986], [-383.256, 57.827], [-381.142, 65.229], [-366.179, 89.258], [-306.78, 92.668], [-277.489, 65.334], [-275.057, 62.401], [-274.344, 62.902]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 3',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [0.984313785329, 0.686274509804, 0.266666666667, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [728.11, 227.299],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 3',
      np: 2,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }],
    ip: 10.8,
    op: 60,
    st: 10.8,
    bm: 0
  }, {
    ddd: 0,
    ind: 22,
    ty: 4,
    nm: 'N-mask-turqoise',
    td: 1,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [750, 375, 0],
        ix: 2
      },
      a: {
        a: 0,
        k: [0, 0, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [-22, 36.75], [-16, 0], [12.25, -49.75], [0, 0], [-48.25, 0], [0, 0]],
            o: [[0, 0], [24.453, -40.848], [16, 0], [-10.25, 37.25], [0, 0], [48.25, 0], [0, 0]],
            v: [[-141.25, 75.25], [-107.75, -45], [-44, -79.25], [-6.5, -37], [-18.75, 12.25], [10.25, 47.25], [65, -29.25]],
            c: false
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'st',
        c: {
          a: 0,
          k: [1, 0, 0, 1],
          ix: 3
        },
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 75,
          ix: 5
        },
        lc: 1,
        lj: 1,
        ml: 4,
        bm: 0,
        nm: 'Stroke 1',
        mn: 'ADBE Vector Graphic - Stroke',
        hd: false
      }, {
        ty: 'tm',
        s: {
          a: 0,
          k: 0,
          ix: 1
        },
        e: {
          a: 1,
          k: [{
            i: {
              x: [0.468],
              y: [0.43]
            },
            o: {
              x: [0.627],
              y: [0]
            },
            t: 7.2,
            s: [0]
          }, {
            i: {
              x: [0.626],
              y: [0.831]
            },
            o: {
              x: [0.295],
              y: [0.183]
            },
            t: 16.8,
            s: [68.576]
          }, {
            i: {
              x: [0.484],
              y: [1]
            },
            o: {
              x: [0.185],
              y: [0.822]
            },
            t: 18,
            s: [83.423]
          }, {
            t: 31.2,
            s: [100]
          }],
          ix: 2
        },
        o: {
          a: 0,
          k: 0,
          ix: 3
        },
        m: 1,
        ix: 4,
        nm: 'Trim Paths 1',
        mn: 'ADBE Vector Filter - Trim',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [0, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Shape 2',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [-30, 105]],
            o: [[0, 0], [13.079, -45.777]],
            v: [[-141.25, 75.25], [-113.25, -110.25]],
            c: false
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'st',
        c: {
          a: 0,
          k: [1, 0, 0, 1],
          ix: 3
        },
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 75,
          ix: 5
        },
        lc: 1,
        lj: 1,
        ml: 4,
        bm: 0,
        nm: 'Stroke 1',
        mn: 'ADBE Vector Graphic - Stroke',
        hd: false
      }, {
        ty: 'tm',
        s: {
          a: 0,
          k: 0,
          ix: 1
        },
        e: {
          a: 1,
          k: [{
            i: {
              x: [0],
              y: [1]
            },
            o: {
              x: [0.333],
              y: [0]
            },
            t: 7.2,
            s: [0]
          }, {
            t: 14.4001953125,
            s: [100]
          }],
          ix: 2
        },
        o: {
          a: 0,
          k: 0,
          ix: 3
        },
        m: 1,
        ix: 4,
        nm: 'Trim Paths 1',
        mn: 'ADBE Vector Filter - Trim',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [0, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Shape 1',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 2,
      mn: 'ADBE Vector Group',
      hd: false
    }],
    ip: 7.2,
    op: 60,
    st: 7.2,
    bm: 0
  }, {
    ddd: 0,
    ind: 23,
    ty: 4,
    nm: 'N-shape-turqoise',
    tt: 1,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [699.449, 359.394, 0],
        ix: 2
      },
      a: {
        a: 0,
        k: [566.87, 235.814, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[10.756, -21.797], [11.395, -11.103], [4.15, -1.533], [-0.581, 8.142], [-1.084, 2.881], [-3.252, 7.745], [2.142, 18.795], [14.909, 3.331], [15.888, -11.209], [9.067, -14.222], [0.925, -1.242], [0.423, 0.238], [-3.728, 15.385], [0, 0], [3.648, -17.606], [3.146, -6.424], [-0.238, -0.159], [0.899, -10.204], [0, 0], [-0.106, 0.819], [-7.64, 21.042], [-10.653, 11.896], [-4.758, 2.247], [-0.74, -7.56], [0.37, -1.506], [2.671, -9.146], [0.186, -13.904], [-14.962, -8.485], [-13.535, 3.014], [-10.283, 11.261], [-3.515, 4.071]],
            o: [[-6.134, 14.46], [-3.171, 3.093], [-7.773, 2.909], [0.212, -3.093], [2.935, -7.878], [7.058, -16.813], [-1.744, -15.2], [-19.43, -4.335], [-13.878, 9.781], [-0.82, 1.295], [-0.423, -0.212], [3.727, -15.253], [0, 0], [-3.675, 17.685], [-1.481, 7.243], [-2.157, 11.772], [-0.872, 9.94], [0, 0], [0.185, -0.977], [2.405, -22.231], [5.366, -14.83], [3.516, -3.939], [6.82, -3.225], [0.159, 1.534], [-2.221, 9.279], [-3.885, 13.166], [-0.211, 16.576], [12.187, 6.926], [15.253, -3.382], [2.986, -3.278], [18.156, -27.801]],
            v: [[-51.944, -0.833], [-77.852, 38.213], [-89.244, 45.481], [-103.414, 34.75], [-101.59, 25.577], [-92.152, 2.182], [-81.288, -50.398], [-109.256, -81.856], [-161.968, -70.33], [-195.408, -33.348], [-198.131, -29.62], [-199.4, -30.281], [-188.244, -76.172], [-250.71, -76.172], [-261.707, -23.302], [-266.281, -1.651], [-274.344, 62.902], [-277.014, 92.986], [-215.023, 92.986], [-214.547, 90.368], [-199.981, 25.339], [-177.697, -15.822], [-164.902, -25.496], [-152.055, -17.46], [-152.266, -12.781], [-159.219, 14.975], [-167.44, 55.104], [-147.27, 94.043], [-108.172, 98.853], [-70.951, 74.931], [-61.594, 64.172]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 3',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [0.274509803922, 0.729411764706, 0.607843137255, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [728.11, 227.299],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 3',
      np: 2,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }],
    ip: 7.2,
    op: 60,
    st: 7.2,
    bm: 0
  }, {
    ddd: 0,
    ind: 24,
    ty: 4,
    nm: 'E-mask-salmon',
    td: 1,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [1107.097, 354.625, 0],
        ix: 2
      },
      a: {
        a: 0,
        k: [357.097, -20.375, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [41.75, 0], [2.5, 34.25], [-33.75, 0], [0, -11.25], [15.5, -3.75]],
            o: [[0, 0], [-41.75, 0], [-1.75, -23.969], [33.75, 0], [0, 11.25], [-15.5, 3.75]],
            v: [[427, -14.75], [353.25, 52.75], [287.25, -9], [358.5, -93.5], [387.5, -56.5], [318.75, -5.5]],
            c: false
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'st',
        c: {
          a: 0,
          k: [1, 0, 0, 1],
          ix: 3
        },
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 69,
          ix: 5
        },
        lc: 1,
        lj: 1,
        ml: 4,
        bm: 0,
        nm: 'Stroke 1',
        mn: 'ADBE Vector Graphic - Stroke',
        hd: false
      }, {
        ty: 'tm',
        s: {
          a: 0,
          k: 0,
          ix: 1
        },
        e: {
          a: 1,
          k: [{
            i: {
              x: [0.468],
              y: [0.572]
            },
            o: {
              x: [0.627],
              y: [0]
            },
            t: 0,
            s: [0]
          }, {
            i: {
              x: [0.619],
              y: [0.831]
            },
            o: {
              x: [0.289],
              y: [0.186]
            },
            t: 6,
            s: [68.576]
          }, {
            i: {
              x: [0.491],
              y: [1]
            },
            o: {
              x: [0.189],
              y: [0.907]
            },
            t: 7.2,
            s: [85.727]
          }, {
            t: 18,
            s: [100]
          }],
          ix: 2
        },
        o: {
          a: 0,
          k: 0,
          ix: 3
        },
        m: 1,
        ix: 4,
        nm: 'Trim Paths 1',
        mn: 'ADBE Vector Filter - Trim',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [0, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Shape 1',
      np: 4,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }],
    ip: 0,
    op: 60,
    st: 0,
    bm: 0
  }, {
    ddd: 0,
    ind: 25,
    ty: 4,
    nm: 'E-shape-salmon',
    tt: 1,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [861.49, 350.26, 0],
        ix: 2
      },
      a: {
        a: 0,
        k: [728.912, 226.679, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[-9.041, 11.367], [-5.737, 1.585], [-0.634, -6.529], [5.657, -6.397], [12.319, -3.754]],
            o: [[3.596, -4.547], [6.344, -1.772], [0.873, 8.777], [-8.247, 9.332], [1.005, -14.91]],
            v: [[227.501, -34.67], [241.141, -44.476], [253.301, -36.282], [245.345, -13.574], [214.099, 4.931]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ind: 1,
        ty: 'sh',
        ix: 2,
        ks: {
          a: 0,
          k: {
            i: [[1.506, -1.957], [7.692, -7.561], [16.945, 1.084], [2.115, 12.451], [-1.507, 0.343], [-12.028, 7.64], [-3.596, 22.39], [19.773, 6.741], [19.642, -8.221], [9.597, -30.216], [2.097, -5.848], [-2.501, -9.484], [-10.89, -7.349], [-28.312, 11.34], [-12.874, 14.672], [-1.375, 1.532]],
            o: [[-6.662, 8.564], [-11.526, 11.34], [-13.006, -0.846], [1.454, -0.397], [13.879, -3.173], [18.267, -11.579], [3.33, -20.673], [-20.594, -7.006], [-30.057, 12.583], [-1.878, 5.933], [-2.576, 9.402], [7.428, 17.712], [26.119, 17.606], [18.293, -7.349], [0.951, -1.084], [23.823, -40.244]],
            v: [[305.776, 11.407], [284.997, 36.389], [242.727, 53.756], [216.557, 31.102], [220.997, 29.886], [260.068, 13.998], [295.599, -35.012], [269.374, -79.397], [208.705, -76.304], [151.922, -9.344], [147.012, 8.719], [150.812, 52.355], [175.397, 86.403], [257.531, 92.774], [303.185, 58.064], [306.488, 54.365]],
            c: true
          },
          ix: 2
        },
        nm: 'Path 3',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'fl',
        c: {
          a: 0,
          k: [0.945098099054, 0.380392186782, 0.317647058824, 1],
          ix: 4
        },
        o: {
          a: 0,
          k: 100,
          ix: 5
        },
        r: 1,
        bm: 0,
        nm: 'Fill 1',
        mn: 'ADBE Vector Graphic - Fill',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [728.11, 227.299],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Group 3',
      np: 3,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }],
    ip: 0,
    op: 60,
    st: 0,
    bm: 0
  }, {
    ddd: 0,
    ind: 26,
    ty: 4,
    nm: 'yellowLine',
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 180,
        ix: 10
      },
      p: {
        a: 0,
        k: [752, 128, 0],
        ix: 2
      },
      a: {
        a: 0,
        k: [2, 129, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [355.684, 96.191], [146, -36]],
            o: [[0, 0], [-318, -86], [-146, 36]],
            v: [[712, 44], [-34, 136], [-716, 172]],
            c: false
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'tm',
        s: {
          a: 1,
          k: [{
            i: {
              x: [0],
              y: [1]
            },
            o: {
              x: [0.588],
              y: [0]
            },
            t: 13.2,
            s: [0]
          }, {
            t: 43.199609375,
            s: [100]
          }],
          ix: 1
        },
        e: {
          a: 1,
          k: [{
            i: {
              x: [0],
              y: [1]
            },
            o: {
              x: [0.588],
              y: [0]
            },
            t: 9.6,
            s: [0]
          }, {
            t: 39.6,
            s: [100]
          }],
          ix: 2
        },
        o: {
          a: 0,
          k: 0,
          ix: 3
        },
        m: 1,
        ix: 2,
        nm: 'Trim Paths 1',
        mn: 'ADBE Vector Filter - Trim',
        hd: false
      }, {
        ty: 'st',
        c: {
          a: 0,
          k: [0.984313785329, 0.686274509804, 0.266666666667, 1],
          ix: 3
        },
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 15,
          ix: 5
        },
        lc: 2,
        lj: 1,
        ml: 4,
        bm: 0,
        nm: 'Stroke 1',
        mn: 'ADBE Vector Graphic - Stroke',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [0, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Shape 1',
      np: 3,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }],
    ip: 9.6,
    op: 60,
    st: 9.6,
    bm: 0
  }, {
    ddd: 0,
    ind: 27,
    ty: 4,
    nm: 'salmonLine',
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [752, 504, 0],
        ix: 2
      },
      a: {
        a: 0,
        k: [2, 129, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        ind: 0,
        ty: 'sh',
        ix: 1,
        ks: {
          a: 0,
          k: {
            i: [[0, 0], [355.684, 96.191], [146, -36]],
            o: [[0, 0], [-318, -86], [-146, 36]],
            v: [[712, 44], [-34, 136], [-716, 172]],
            c: false
          },
          ix: 2
        },
        nm: 'Path 1',
        mn: 'ADBE Vector Shape - Group',
        hd: false
      }, {
        ty: 'tm',
        s: {
          a: 1,
          k: [{
            i: {
              x: [0],
              y: [1]
            },
            o: {
              x: [0.588],
              y: [0]
            },
            t: 9.6,
            s: [0]
          }, {
            t: 39.599609375,
            s: [100]
          }],
          ix: 1
        },
        e: {
          a: 1,
          k: [{
            i: {
              x: [0],
              y: [1]
            },
            o: {
              x: [0.588],
              y: [0]
            },
            t: 6,
            s: [0]
          }, {
            t: 36,
            s: [100]
          }],
          ix: 2
        },
        o: {
          a: 0,
          k: 0,
          ix: 3
        },
        m: 1,
        ix: 2,
        nm: 'Trim Paths 1',
        mn: 'ADBE Vector Filter - Trim',
        hd: false
      }, {
        ty: 'st',
        c: {
          a: 0,
          k: [0.945098099054, 0.380392186782, 0.317647058824, 1],
          ix: 3
        },
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 15,
          ix: 5
        },
        lc: 2,
        lj: 1,
        ml: 4,
        bm: 0,
        nm: 'Stroke 1',
        mn: 'ADBE Vector Graphic - Stroke',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [0, 0],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Shape 1',
      np: 3,
      cix: 2,
      bm: 0,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }],
    ip: 6,
    op: 60,
    st: 6,
    bm: 0
  }],
  markers: []
};